const dimensions = {
  supplier: { state: 'selectedSuppliers', id: 'partner', name: order => order?.partner_name },
  manager: { state: 'selectedManagers', id: 'user', name: order => `${order?.user_last_name || ''} ${order?.user_name || ''}`.trim() },
  office: { state: 'selectedOffices', id: 'filial', name: order => order?.filial_name },
};

export function dimensionValue(order, key) {
  const dimension = dimensions[key];
  return String(order?.[dimension.id] ?? dimension.name(order) ?? '');
}

export function filterOrderFacets(orders, filters, { exclude = '', dateMatches = () => true, normalizeSearch = value => String(value ?? '').toLowerCase() } = {}) {
  const search = normalizeSearch(filters.invoiceOrderSearch);
  return (orders || []).filter(order => {
    if (filters.selectedStatuses.length && !filters.selectedStatuses.includes(order.status)) return false;
    if (filters.showRefusalPositionsOnly && !order.has_refusal_positions) return false;
    if (!dateMatches(order)) return false;
    if (search && !['invois', 'number', 'supplier_number'].some(field => normalizeSearch(order[field]).includes(search))) return false;
    return Object.entries(dimensions).every(([key, dimension]) => {
      const selected = filters[dimension.state] || [];
      return key === exclude || !selected.length || selected.some(value => String(value) === dimensionValue(order, key) || String(value) === dimension.name(order));
    });
  });
}

export function orderFacetOptions(allOrders, candidates, filters, key, labelGetter) {
  const dimension = dimensions[key];
  const options = new Map();
  for (const order of candidates) {
    const legacySelected = (filters[dimension.state] || []).find(value => String(value) === dimension.name(order));
    const value = legacySelected === undefined ? dimensionValue(order, key) : String(legacySelected);
    if (value) options.set(value, { value, label: labelGetter(order) });
  }
  // Only restore labels from orders in the authorized source list; keep legacy saved name values.
  for (const selected of filters[dimension.state] || []) {
    const value = String(selected);
    const order = (allOrders || []).find(order => value === dimensionValue(order, key) || value === dimension.name(order));
    if (order) options.set(value, { value, label: labelGetter(order) });
  }
  return [...options.values()];
}
